'use client';

import { useEffect } from 'react';
import type { BrandPreviewId } from '@/lib/brand-preview/shared';

/**
 * Owns the data-brand-preview attribute lifecycle on <html> after hydration.
 * The inline script in BrandPreviewSkin handles the pre-paint case on full
 * loads; this effect covers client-side navigations INTO a skinned layout and
 * removes the attribute when the skinned layout unmounts, so no stale
 * attribute lingers on unskinned surfaces.
 */
export function BrandPreviewAttribute({ brand }: { brand: BrandPreviewId }) {
  useEffect(() => {
    document.documentElement.setAttribute('data-brand-preview', brand);
    return () => {
      document.documentElement.removeAttribute('data-brand-preview');
    };
  }, [brand]);
  return null;
}
